import { css, keyframes } from 'styled-components';

const slideUp = keyframes`
0% {
  opacity: 0; 
  transform: translateY(100%);
}
100%{
  opacity: 1; 
  transform: translateY(0);
}`;

export const SlideUp = css`
  -webkit-animation: ${slideUp} 0.5s cubic-bezier(0.25, 0.25, 0.75, 0.75);
  animation: ${slideUp} 0.5s cubic-bezier(0.25, 0.25, 0.75, 0.75);
`;
